import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface IToastProps {
  text: string;
  classNames?: string;
  maskClassName?: string;
  mask?: boolean;
  icon?: string;
}

const Toast: React.FC<IToastProps> = (props) => {
  const {
    text,
    classNames: className,
    mask = true,
    icon,
    maskClassName,
  } = props;
  const [animateClassName, setAnimateClassName] = useState(styles.popEnter);
  useEffect(() => {
    setAnimateClassName('');
  }, []);
  return (
    <div className={styles.dialog}>
      {mask ? <div className={classNames(styles.mask, maskClassName)} /> : null}

      <div
        className={classNames(
          styles.toast,
          styles.placeMiddle,
          className,
          animateClassName,
        )}
      >
        <img hidden={!icon} src={icon} className={styles.icon}></img>
        <span className={styles.toastText}>{text}</span>
      </div>
    </div>
  );
};

export default Toast;
